import http from 'services/http-service';

const MemberService = {
    GetAll(keyword: string, skipCount: number, maxResultCount: number) {
        let response = http.get('/members', { params: { keyword: keyword, skipCount: skipCount, maxResultCount: maxResultCount } });
        return response;
    },
    GetMember(id: any) {
        let response = http.get('/members/' + id);
        return response;
    },
    ChangeAccountDetail(memberId: any, email: string, phone: string) {
        let response = http.put('/members/changeDetail', { id: memberId, email: email, phone: phone });
        return response;
    },
    ChangePassword(memberId: any, password: string, confirmPassword: string) {
        let response = http.put('/members/changePassword', { id: memberId, newPassword: password, confirmNewPassword: confirmPassword });
        return response;
    }
};

export default MemberService;